<template>
	<div>
		<Loader :show="loading" type="absolute" />

		<div class="" v-if="!loading">
			<div class="product-card">
				<div class="product-data">
					<span v-if="product.laboratory">{{ product.laboratory.name }}<br /></span>
					<h2 class="m-0">{{ product.name }}</h2>
					<div class="text-primary">
						<small v-for="(droug, i) in product.drougs" :key="i">{{ droug }}</small>
					</div>
				</div>
				<div class="d-flex mt-3" v-if="qty || expireAt">
					<div v-if="qty" class="box">
						<div class="label">Cantidad</div>
						{{ qty }}
					</div>
					<!-- <div v-if="expireAt" class="box ">
						<div class="label">Límite para dispensar</div>
						{{ expireAt | moment("DD-MM-YYYY") }}
					</div> -->
					
				</div>
				<div v-if="indications" class="box">
					<div class="label">Indicaciones</div>
					{{ indications }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "ProductCard",
	props: {
		product: {
			required: true
		},
		qty: {
			type: Number | String
		},
		expireAt: {
			type: String
		},
		indications: {
			type: String
		}
	},
	data() {
		return {
			loading: false
		}
	},
	async beforeMount() {
		this.loading = true
		this.loading = false
	}
}
</script>

<style scoped>
h2 {
	font-size: 1.1rem;
}
h2 small {
	font-size: 0.75rem;
}

.product-card {
	color: #000;
	padding: 8px;
	border-radius: 4px;
}
.product-data {
}

.box {
	background-color: #f3f3f3;
	padding: 0.5rem !important;
	text-align: center;
	flex-grow: 1;
	margin: 3px;
}

.label {
	font-weight: 500;
	font-size: 12px;
}
</style>
